import React from 'react';
import styled from 'styled-components';
import { Flex } from 'rebass';
import Label from 'shared/components/label';
import ErrorIcon from 'shared/icons/error.svg';
import { colors } from 'shared/styles/settings';

const Overlay = styled(Flex)`
  align-items: center;
  background-color: #fff;
  bottom: 0;
  flex-direction: column;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 1px;
`;

const StyledErrorIcon = styled(ErrorIcon)`
  background-color: #fff;
  fill: ${colors.danger};
  height: 5rem;
  margin-bottom: 2rem;
  width: 5rem;
`;

export const ErrorScreen = () => (
  <Overlay column align="center" justify="center">
    <StyledErrorIcon />
    <Label fontWeight="bold" color={colors.brown} fontSize="1.375rem">
      You do not have permission to view this page
    </Label>
  </Overlay>
);
